var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { defineProps, nodeProps } from '../props';
import { mark } from '../mark';
import { CompositionNode } from './index';
let SpaceLayer = class SpaceLayer extends CompositionNode {
    constructor() {
        super({}, 'spaceLayer');
    }
};
SpaceLayer = __decorate([
    defineProps([{ type: 'value', name: 'data' }, ...nodeProps(mark)])
], SpaceLayer);
export { SpaceLayer };
//# sourceMappingURL=spaceLayer.js.map